/**
 * MoveHistory Component
 * Displays the list of moves in chess notation
 */

import React from 'react';
import type { AnnotatedMove } from '../../engine/notation';
import './MoveHistory.css';

interface MoveHistoryProps {
  moves: AnnotatedMove[];
  onMoveClick?: (index: number) => void;
  currentMoveIndex?: number; // Index of currently viewed move (-1 = start position)
}

export const MoveHistory: React.FC<MoveHistoryProps> = ({ moves, onMoveClick, currentMoveIndex = -1 }) => {
  // Group moves into pairs (white move, black move)
  const movePairs: Array<{ white: AnnotatedMove | null; black: AnnotatedMove | null; moveNumber: number }> = [];
  
  for (let i = 0; i < moves.length; i += 2) {
    movePairs.push({
      white: moves[i] || null,
      black: moves[i + 1] || null,
      moveNumber: Math.floor(i / 2) + 1
    });
  }
  
  return (
    <div className="move-history">
      <h3 className="move-history-title">Move History</h3>
      <div className="move-history-scroll">
        {movePairs.length === 0 ? (
          <div className="move-history-empty">No moves yet</div>
        ) : (
          <table className="move-history-table">
            <tbody>
              {movePairs.map((pair, index) => (
                <tr key={index} className="move-history-row">
                  <td className="move-number">{pair.moveNumber}.</td>
                  <td 
                    className={`move-notation ${onMoveClick ? 'clickable' : ''} ${index * 2 === currentMoveIndex ? 'current-move' : ''} ${index * 2 === moves.length - 1 ? 'last-move' : ''}`}
                    onClick={() => onMoveClick?.(index * 2)}
                  >
                    {pair.white?.notation || ''}
                  </td>
                  <td 
                    className={`move-notation ${onMoveClick ? 'clickable' : ''} ${index * 2 + 1 === currentMoveIndex ? 'current-move' : ''} ${index * 2 + 1 === moves.length - 1 ? 'last-move' : ''}`}
                    onClick={() => pair.black && onMoveClick?.(index * 2 + 1)}
                  >
                    {pair.black?.notation || ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
